module.exports = __webpack_public_path__ + "static/about-insta-12@2x-34845dd1a6e9f0689cef87defeed44a7.jpg";